"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _FreeWithCredit = _interopRequireDefault(require("../FreeWithCredit"));

var _SEMFreeCard = _interopRequireDefault(require("../SEMFreeCard"));

function SMEFreeCard(props) {
  var _a = props.style,
      style = _a === void 0 ? {} : _a,
      title = props.title,
      cardListData = props.cardListData,
      actionConfigData = props.actionConfigData,
      onCallback = props.onCallback;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'sme-container-include',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement(_FreeWithCredit["default"], {
    flexTitle: title,
    onCallback: onCallback,
    configuration: actionConfigData
  }), /*#__PURE__*/_react["default"].createElement(_SEMFreeCard["default"], {
    configuration: cardListData
  }));
}

var _default = SMEFreeCard;
exports["default"] = _default;